
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class QualityInspectionDialog extends Serenity.EntityDialog<QualityInspectionRow, any> {
        protected getFormKey() { return QualityInspectionForm.formKey; }
        protected getIdProperty() { return QualityInspectionRow.idProperty; }
        protected getLocalTextPrefix() { return QualityInspectionRow.localTextPrefix; }
        protected getNameProperty() { return QualityInspectionRow.nameProperty; }
        protected getService() { return QualityInspectionService.baseUrl; }
        protected getDeletePermission() { return QualityInspectionRow.deletePermission; }
        protected getInsertPermission() { return QualityInspectionRow.insertPermission; }
        protected getUpdatePermission() { return QualityInspectionRow.updatePermission; }

        protected form = new QualityInspectionForm(this.idPrefix);

    }
}